import IconCatch from '@/components/icons/icon-catch/icon-catch';
import useIsMobile from '@/hooks/use-is-mobile';
import { Box, Text } from '@cmpsr/components';

export default function EmptyState() {
  const isMobile = useIsMobile();

  return (
    <Box
      py={{ base: 'spacer-6', lg: 'spacer-12' }}
      px={{ base: 'spacer-6', lg: 'spacer-24' }}
      textAlign="center"
      border="1px solid"
      borderRadius="10px"
      borderColor="ui-element-divider"
      width="100%"
    >
      <IconCatch
        icon="risk-impact"
        size={isMobile ? 'xl' : 'xxl'}
        borderRadius="10px"
        backgroundColor="background-page-03"
        mx="auto"
      />
      <Text variant="text-header-2XL" mt="spacer-8" mb={{ base: 'spacer-3', lg: 'spacer-4' }}>
        No{' '}
        <Text as="span" textStyle="text-header-2xl-v">
          trends
        </Text>{' '}
        identified yet
      </Text>
      <Text variant="text-header-M" color="text-secondary">
        Complete items on your Action Plan and update your Risk Assessment to see changes over time
      </Text>
    </Box>
  );
}
